module.exports = __webpack_public_path__ + "static/media/cert-tst-white.2eaaa002.svg";